import request from '@/utils/request';
import { getCountryRegion } from '@/utils/countryRegion';

export type codeType = 'Eco_Credits_Day_Solar' | 'Eco_Credits_Day_Storge' | 'Eco_Credits_Day_Usage' | 'Eco_Credits_Day_WN_Usage';

export type paramObjType = {
    code: codeType;
};

/**
 * 会员日 AppData 查询
 * @params{
 *      @param  code
 *          enum:   Eco_Credits_Day_Solar       发电统计
 *                  Eco_Credits_Day_Storge      储电统计
 *                  Eco_Credits_Day_Usage       用电统计
 *                  Eco_Credits_Day_WN_Usage    微逆统计
 *      @param  params: {
 *                  userId: 用户id
 *              }
 * }
 */
export const queryStatistics = async (data: paramObjType, locale: string) => {
    const isEU = getCountryRegion(locale) === 'eu';
    const HOST_STS = isEU ? process.env.NEXT_PUBLIC_STS_HOST_EU : process.env.NEXT_PUBLIC_STS_HOST;
    return request.post(`${HOST_STS}/iot-service/index/common/query`, {
        data,
        needToken: true,
    });
};
